import { Alert, Header, Flex, Icon, Tooltip } from 'govwell-ui'

import Text, { TextSize } from 'src/components/Typography/Text'
import { withForm } from 'src/hooks/use-app-form'
import { aiLauncherSettingsFormOptions } from 'src/pages/AIAssistantSettingsPage/launcherSettingsForm'

const AIAssistantInstallation = withForm({
  ...aiLauncherSettingsFormOptions,
  props: {
    isAIChatEnabled: false,
  },
  render: ({ form, isAIChatEnabled }) => {
    return (
      <Flex direction="column" gap={6} align="start" width="100%">
        {!isAIChatEnabled && (
          <Alert
            variant="warning"
            showIcon
            title="Community Assistant Not Enabled"
            description='Your organization has not enabled the Community Assistant. The install script below will not work until the Community Assistant has been enabled. To get started, click the "Contact us about the Community Assistant" button in the top right.'
          />
        )}
        <Flex direction="column" gap={4} align="start" width="100%">
          <Header title="Launcher Settings" />
          <form.AppField name="allowListUrls">
            {(field) => (
              <field.CreatableStringSelect
                caption={
                  <Text colorToken="colorTextTertiary" size={TextSize.Small}>
                    Enter all URLs where the Community Assistant should be enabled. The Community
                    Assistant will only appear if the exact URL is in this allow list, e.g.
                    &quot;https://govwell.com/&quot;.
                  </Text>
                }
                field={field}
                label="URL Allow List"
                placeholder="Type to add URLs"
              />
            )}
          </form.AppField>
          <Flex gap={3} wrap="wrap" align="start" width="100%">
            <Flex flex={1}>
              <form.AppField name="position">
                {(field) => <field.AIChatLauncherPositionSelect field={field} label="Position" />}
              </form.AppField>
            </Flex>
            <Flex flex={1}>
              <form.AppField name="bottomSpacingPx">
                {(field) => <field.Number field={field} label="Bottom Spacing (pixels)" />}
              </form.AppField>
            </Flex>
            <Flex flex={1}>
              <form.AppField name="sideSpacingPx">
                {(field) => <field.Number field={field} label="Side Spacing (pixels)" />}
              </form.AppField>
            </Flex>
          </Flex>
          <Flex gap={3} direction="row" width="100%">
            <form.AppField name="popupEnabled">
              {(field) => (
                <Tooltip content="Enable a dialog message to inform users about the Community Assistant.">
                  <div style={{ minWidth: '150px' }}>
                    <field.Switch
                      field={field}
                      label={
                        <Text inline>
                          Dialog enabled <Icon.FaQuestionCircle />
                        </Text>
                      }
                    />
                  </div>
                </Tooltip>
              )}
            </form.AppField>
            <form.AppField name="popupTitle">
              {(field) => <field.Input field={field} label="Dialog title" />}
            </form.AppField>
            <form.AppField name="popupDescription">
              {(field) => <field.Input field={field} label="Dialog description" />}
            </form.AppField>
          </Flex>
        </Flex>
      </Flex>
    )
  },
})

export default React.memo(AIAssistantInstallation)
